export default __webpack_public_path__ + "static/media/sample1.ce25345e.png";